// extracted by mini-css-extract-plugin
module.exports = {"contactsTable":"contactsTable__B-hqA","badge":"badge__KoFsx"};